<template>
  <div>
    <van-image class="q_rank_bg" fit="cover" :src="require('../../assets/image/rank.png')"/>
    <!-- 队伍排行榜只需要里面那层van-tabs，将本div的'q_mar_t10px'改为'q_mar_t70px' -->
    <div class="q_mar_t10px" v-if="!loading">
      <van-tabs v-model="active1">
        <van-tab title="服务时长">
          <div class="q_pad_tb10px">
            <van-tabs v-model="active" type="card" class="q_tab_card" @click="onClick">
              <van-tab title="当月榜">
                <div class="q_ranktop">
                  <div class="q_rone" @click="GotoRankdea('month',top2.deptId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/two.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top2.pic"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top2.deptName }}
                    </div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top2.timeLong + '小时' }}</div>
                  </div>
                  <div class="q_rtwo" @click="GotoRankdea('month',top1.deptId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/one.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top1.pic"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top1.deptName }}</div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top1.timeLong + '小时' }}</div>
                  </div>
                  <div class="q_rthree" @click="GotoRankdea('month',top3.deptId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/three.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top3.pic"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top3.deptName }}
                    </div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top3.timeLong + '小时' }}</div>
                  </div>
                </div>
                <div class="q_rank">
                  <div class="q_vertical_left q_pad_tb10px q_bor_top" @click="GotoRankdea('month',item.deptId)"
                       v-for="item,index in list">
                    <div class="q_inlineblock q_rnum q_center">
                      <span class="q_text_l q_bold q_color_gray">{{ index + 4 }}</span>
                    </div>
                    <div class="q_inlineblock q_mar_l10px">
                      <van-image class="q_join_img" fit="cover"
                                 :src="item.pic"/>
                    </div>
                    <div class="q_mar_l15px q_inlineblock q_con">
                      <div class="q_text_m q_bold q_moit2 q_justify">{{ item.deptName }}</div>
                    </div>
                    <div class="q_inlineblock q_right q_time">
                      <span class="q_text_s q_color_default q_bold">{{ item.timeLong + '小时' }}</span>
                    </div>
                  </div>
                </div>
              </van-tab>
              <van-tab title="季度榜">
                <div class="q_ranktop">
                  <div class="q_rone" @click="GotoRankdea('quarter',top2.deptId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/two.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top2.pic"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top2.deptName }}
                    </div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top2.timeLong + '小时' }}</div>
                  </div>
                  <div class="q_rtwo" @click="GotoRankdea('quarter',top1.deptId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/one.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top1.pic"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top1.deptName }}</div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top1.timeLong + '小时' }}</div>
                  </div>
                  <div class="q_rthree" @click="GotoRankdea('quarter',top3.deptId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/three.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top3.pic"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top3.deptName }}
                    </div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top3.timeLong + '小时' }}</div>
                  </div>
                </div>
                <div class="q_rank">
                  <div class="q_vertical_left q_pad_tb10px q_bor_top" @click="GotoRankdea('quarter',item.deptId)"
                       v-for="item,index in list">
                    <div class="q_inlineblock q_rnum q_center">
                      <span class="q_text_l q_bold q_color_gray">{{ index + 4 }}</span>
                    </div>
                    <div class="q_inlineblock q_mar_l10px">
                      <van-image class="q_join_img" fit="cover"
                                 :src="item.pic"/>
                    </div>
                    <div class="q_mar_l15px q_inlineblock q_con">
                      <div class="q_text_m q_bold q_moit2 q_justify">{{ item.deptName }}</div>
                    </div>
                    <div class="q_inlineblock q_right q_time">
                      <span class="q_text_s q_color_default q_bold">{{ item.timeLong + '小时' }}</span>
                    </div>
                  </div>
                </div>
              </van-tab>
              <van-tab title="年度榜">
                <div class="q_ranktop">
                  <div class="q_rone" @click="GotoRankdea('year',top2.deptId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/two.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top2.pic"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top2.deptName }}
                    </div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top2.timeLong + '小时' }}</div>
                  </div>
                  <div class="q_rtwo" @click="GotoRankdea('year',top1.deptId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/one.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top1.pic"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top1.deptName }}</div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top1.timeLong + '小时' }}</div>
                  </div>
                  <div class="q_rthree" @click="GotoRankdea('year',top3.deptId)">
                    <van-image class="q_crown" fit="cover"
                               :src="require('../../assets/image/three.png')"/>
                    <van-image class="q_join_img" fit="cover"
                               :src="top3.pic"/>
                    <div class="q_text_m q_bold q_color_white q_mar_t15px q_moit2">{{ top3.deptName }}
                    </div>
                    <div class="q_text_s q_mar_t5px q_color_white">{{ top3.timeLong + '小时' }}</div>
                  </div>
                </div>
                <div class="q_rank">
                  <div class="q_vertical_left q_pad_tb10px q_bor_top" @click="GotoRankdea('year',item.deptId)"
                       v-for="item,index in list">
                    <div class="q_inlineblock q_rnum q_center">
                      <span class="q_text_l q_bold q_color_gray">{{ index + 4 }}</span>
                    </div>
                    <div class="q_inlineblock q_mar_l10px">
                      <van-image class="q_join_img" fit="cover"
                                 :src="convertImg(item.pic)"/>
                    </div>
                    <div class="q_mar_l15px q_inlineblock q_con">
                      <div class="q_text_m q_bold q_moit2 q_justify">{{ item.deptName }}</div>
                    </div>
                    <div class="q_inlineblock q_right q_time">
                      <span class="q_text_s q_color_default q_bold">{{ item.timeLong + '小时' }}</span>
                    </div>
                  </div>
                </div>
              </van-tab>
            </van-tabs>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import {userActivityTimeDeptMonth, userActivityTimeDeptQuarter, userActivityTimeDeptYear} from "@/api/userActivity";
import {wxCloseShare} from "@/utils/jiutang";

export default {
  name: 'Join',
  props: {
    msg: String
  },
  data() {
    return {
      loading:true,
      active1: 0,
      active: 0,
      top1: undefined,
      top2: undefined,
      top3: undefined,
      list: [],
    }
  },
  created() {
    wxCloseShare()
    this.getMonth()
  },
  methods: {
    getMonth() {
      this.loading = true
      this.$modal.loading()
      // 获取当月
      userActivityTimeDeptMonth().then(res => {
        this.top1 = res.data.top1
        this.top2 = res.data.top2
        this.top3 = res.data.top3
        this.list = res.data.list
      }).finally(() => {
        this.loading = false
        this.$modal.closeLoading()
      })
    },
    getQuarter() {
      this.$modal.loading()
      // 获取当月
      userActivityTimeDeptQuarter().then(res => {
        this.top1 = res.data.top1
        this.top2 = res.data.top2
        this.top3 = res.data.top3
        this.list = res.data.list
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    getYear() {
      this.$modal.loading()
      // 获取当月
      userActivityTimeDeptYear().then(res => {
        this.top1 = res.data.top1
        this.top2 = res.data.top2
        this.top3 = res.data.top3
        this.list = res.data.list
      }).finally(() => {
        this.$modal.closeLoading()
      })
    },
    onClick(name, title) {
      if (title == '当月榜') {
        this.getMonth()
      }
      if (title == '季度榜') {
        this.getQuarter()
      }
      if (title == '年度榜') {
        this.getYear()
      }
    },
    GotoRankdea(type, deptId) {
      this.$router.push({
        path: '/home/Rankdea',
        query: {'type': type, 'deptId': deptId}
      });
    },
  },
}
</script>
<style scoped="scoped">
.q_join_img {
  width: 40px;
  height: 40px;
}

.q_join_img >>> .van-image__img {
  border-radius: 30px;
}

.q_con {
  width: 150px;
}

.q_time {
  width: 90px;
}

.q_rnum {
  width: 40px;
}

.q_rank {
  background-color: #ffffff;
  border-radius: 15px 15px 0 0;
  padding: 0 15px;
  margin-top: 255px;
}

.q_rank_bg {
  width: 100vw;
  position: absolute;
  top: 0;
  left: 0;
}

>>> .van-tabs--card > .van-tabs__wrap {
  height: 40px;
}

>>> .van-tabs__nav {
  background-color: rgba(255, 255, 255, 0);
}

>>> .van-tab {
  color: rgba(255, 255, 255, .8);
}

>>> .van-tab--active {
  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
}

>>> .van-tabs__line {
  height: 0;
}

.q_tab_card >>> .van-tabs__nav {
  background-color: rgba(255, 255, 255, .4);
  height: 40px;
  border-radius: 30px;
  border: none;
  margin: 0 40px;
}

.q_tab_card >>> .van-tabs__nav--card .van-tab.van-tab--active {
  color: #FF5733;
  font-weight: bold;
  background-color: #ffffff;
  font-size: 14px;
}

.q_tab_card >>> .van-tabs__nav--card .van-tab {
  color: #ffffff;
  border-right: 1px solid #ffffff;
  border-radius: 30px;
}

.q_ranktop {
  position: absolute;
  margin-top: -190px;
  width: 100%;
}

.q_ranktop .q_join_img {
  width: 60px;
  height: 60px;
  border-radius: 30px;
  border: 2px solid rgba(255, 255, 255, .6);
}

.q_rone,
.q_rtwo,
.q_rthree {
  position: absolute;
  width: 105px;
  text-align: center;
}

.q_rone {
  top: 24px;
  left: 20px;
}

.q_rtwo {
  top: 0px;
  left: 135px;
}

.q_rthree {
  top: 40px;
  left: 250px;
}

.q_crown {
  position: absolute;
  top: -24px;
  left: 34px;
  width: 40px;
}
</style>
